module.exports = __webpack_public_path__ + "images/powerups/voting-icon.849821308b83ed448d78.svg";